import { render, staticRenderFns } from "./TrafxPage.vue?vue&type=template&id=723a59d2"
import script from "./TrafxPage.vue?vue&type=script&lang=js"
export * from "./TrafxPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports